import { PayTypeEnum } from 'types/enum'
import { SET_GOODS, SET_CURGOODS, SET_PAYTYPE, SET_PAYMENTS, SET_SOURCE, SET_COUPON, CAPTCHA_TYPE,IS_DEFAULT_COUPON } from "store/ActionTypes"
import { Action, GoodsType } from "types/interface"

export interface RechargeState {
  goods: GoodsType[],
  curGoods: GoodsType | {},
  payType: PayTypeEnum | null,
  payments: string[],
  source: string | null,
  couponPrice: string[] | any,
  captchaType: string,
  is_default_coupon: boolean
}

const defaultState: RechargeState = {
  goods: [],
  curGoods: { default: true },
  payType: null,
  payments: [],
  source: null,
  couponPrice: [],
  captchaType: '',
  is_default_coupon:false
}

const actionToState = {
  [SET_GOODS]: 'goods',
  [SET_CURGOODS]: 'curGoods',
  [SET_PAYTYPE]: 'payType',
  [SET_PAYMENTS]: 'payments',
  [SET_SOURCE]: 'source',
  [SET_COUPON]: 'couponPrice',
  [CAPTCHA_TYPE]: 'captchaType',
  [IS_DEFAULT_COUPON]:'is_default_coupon'
}

export default (state = defaultState, action: Action) => {
  const key = actionToState[action.type]
  if (key) {
    return Object.assign({}, state, {
      [key]: action.value
    })
  }
  return state
}
